export default {"src":"/_next/static/media/wstETH.73736658.svg","height":80,"width":80};